import { mapEmailConfigurationApiModel } from './mapEmailConfigurationApiModel'
import { mapPaymentTermApiModel } from './mapPaymentTermApiModel'
import { mapShippingMethodApiModel } from './mapShippingMethodApiModel'
import { mapShippingTermApiModel } from './mapShippingTermApiModel'
import { type VendorConstructor } from '../../entities/Vendor'
import { type VendorApiModel } from '../api-models/VendorApiModel'

export const mapVendorApiModel = (data: VendorApiModel): VendorConstructor => ({
  id: data.id,
  externalId: data.external_id ?? '',
  name: data.name,
  active: data.active,
  address: {
    addressLineOne: data.addressLineOne ?? '',
    addressLineTwo: data.addressLineTwo ?? '',
    postalCode: data.postalCode ?? '',
    city: data.city ?? '',
    stateProvince: data.state_province ?? '',
    country: data.country ?? '',
  },
  contactInfo: {
    phoneOne: data.phoneOne ?? '',
    phoneTwo: data.phoneTwo ?? '',
    fax: data.fax ?? '',
    email: data.email,
    contact: data.contact ?? '',
    url: data.url ?? '',
    emailConfigurations: mapEmailConfigurationApiModel(
      data.email_configurations
    ),
  },
  comments: data.comments ?? '',
  dateModified: data.dateModified,
  paymentTerm: data.payment_term_ref
    ? mapPaymentTermApiModel(data.payment_term_ref)
    : null,
  shippingTerm: data.shipping_term_ref
    ? mapShippingTermApiModel(data.shipping_term_ref)
    : null,
  shippingMethod: data.shipping_method_ref
    ? mapShippingMethodApiModel(data.shipping_method_ref)
    : null,
  taxId: data.tax ?? null,
  legalName: data.legal_name ?? null,
  taxIdMasked: data.vendor_tax_id_masked ?? null,
  taxIdType: data.vendor_tax_id_type ?? null,
  taxIdTypeLabel: data.vendor_tax_id_type_label ?? null,
  taxCountry: data.vendor_tax_country ?? null,
  companyEmail: data.company_email ?? null,
  companyPhone: data.company_phone ?? null,
  taxDocuments: (data.tax_documents ?? []).map((doc) => ({
    id: doc.uuid ?? null,
    docType: doc.doc_type,
    originalFilename: doc.original_filename ?? null,
    uploadedAt: doc.uploaded_at,
  })),
  taxIdProvided: data.tax_id_provided ?? false,
  taxDocumentUploaded: data.tax_document_uploaded ?? false,
  type: data.type,
  pdfLabelSet: data.po_pdf_labels ?? '',
  isAutoEmailPoEnabled: data.is_auto_email_po_enabled ?? false,
  request: data.vendor_request
    ? {
        id: data.vendor_request.id,
        name: data.vendor_request.name,
        requester: data.vendor_request.requester,
        submittedDate: data.vendor_request.submitted_date,
        nextApproverName: data.vendor_request.next_approver,
        permissions: {
          canApprove: data.vendor_request.permissions.can_approve ?? false,
          canEdit: data.vendor_request.permissions.can_edit ?? false,
          canDelete: data.vendor_request.permissions.can_delete ?? false,
        },
      }
    : null,
})
